import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import s from './Notification.module.css';

import { ReactComponent as DelIcon } from 'icons/del.svg';
import { ReactComponent as AlertIcon } from 'icons/alert.svg';
import { ReactComponent as CheckedIcon } from 'icons/checked.svg';

const ICONS = {
  success: <CheckedIcon className={s.icon} />,
  error: <AlertIcon className={s.icon} />,
  info: <CheckedIcon className={s.icon} />,
};

const Notification = ({ text, type, onClose }) => (
  <div className={cn(s.root, s[type])}>
    {ICONS[type]}
    <div className={s.text}>{text}</div>
    <DelIcon className={s.close} onClick={onClose} />
  </div>
);

Notification.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info']),
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

Notification.defaultProps = {
  type: 'success',
};

export default Notification;
